export default __webpack_public_path__ + "static/media/active_customer.1ae06aa5.png";